import React from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShoppingBag, Plus, Minus, Trash2 } from 'lucide-react';
import { useStore } from '../store/useStore';
export function CartDrawer() {
  const {
    cart,
    isCartOpen,
    toggleCart,
    removeFromCart,
    updateQuantity
  } = useStore();
  const subtotal = cart.reduce((acc, item) => {
    const price = parseFloat((item.salePrice || item.price).replace('$', ''));
    return acc + price * item.quantity;
  }, 0);
  return <AnimatePresence data-id="element-62">
      {isCartOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => toggleCart(false)} className="fixed inset-0 z-[110] bg-black/40 backdrop-blur-sm" data-id="element-63" />
          <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed right-0 top-0 bottom-0 z-[120] w-full max-w-md bg-white shadow-2xl flex flex-col" data-id="element-64">
            <div className="p-6 border-b border-gray-100 flex justify-between items-center" data-id="element-65">
              <div className="flex items-center gap-3" data-id="element-66">
                <ShoppingBag size={20} className="text-gold" data-id="element-67" />
                <h2 className="text-lg font-serif" data-id="element-68">
                  Your Shopping Bag ({cart.length})
                </h2>
              </div>
              <button onClick={() => toggleCart(false)} className="p-2 hover:bg-gray-50 rounded-full transition-colors" data-id="element-69">
                <X size={24} data-id="element-70" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6 space-y-8" data-id="element-71">
              {cart.length === 0 ? <div className="h-full flex flex-col items-center justify-center text-center space-y-6" data-id="element-72">
                  <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center text-gray-300" data-id="element-73">
                    <ShoppingBag size={40} data-id="element-74" />
                  </div>
                  <div data-id="element-75">
                    <h3 className="text-xl font-serif mb-2" data-id="element-76">
                      Your bag is empty
                    </h3>
                    <p className="text-gray-400 text-sm" data-id="element-77">
                      Looks like you haven't added anything yet.
                    </p>
                  </div>
                  <button onClick={() => toggleCart(false)} className="bg-black text-white px-8 py-3 text-xs uppercase tracking-widest font-bold hover:bg-gold transition-colors" data-id="element-78">
                    Start Shopping
                  </button>
                </div> : cart.map(item => <div key={item.id} className="flex gap-4 group" data-id="element-79">
                    <div className="w-24 h-32 bg-gray-50 flex-shrink-0 overflow-hidden" data-id="element-80">
                      <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-81" />
                    </div>
                    <div className="flex-1 flex flex-col py-1" data-id="element-82">
                      <div className="flex justify-between items-start mb-1" data-id="element-83">
                        <h4 className="text-xs font-bold uppercase tracking-widest line-clamp-1" data-id="element-84">
                          {item.name}
                        </h4>
                        <button onClick={() => removeFromCart(item.id)} className="text-gray-300 hover:text-red-500 transition-colors" data-id="element-85">
                          <Trash2 size={16} data-id="element-86" />
                        </button>
                      </div>
                      <p className="text-[10px] text-gray-400 uppercase tracking-widest mb-4" data-id="element-87">
                        {item.collection}
                      </p>
                      <div className="mt-auto flex justify-between items-center" data-id="element-88">
                        <div className="flex items-center border border-gray-100" data-id="element-89">
                          <button onClick={() => updateQuantity(item.id, -1)} className="p-2 hover:text-gold transition-colors" data-id="element-90">
                            <Minus size={12} data-id="element-91" />
                          </button>
                          <span className="w-8 text-center text-xs font-bold" data-id="element-92">
                            {item.quantity}
                          </span>
                          <button onClick={() => updateQuantity(item.id, 1)} className="p-2 hover:text-gold transition-colors" data-id="element-93">
                            <Plus size={12} data-id="element-94" />
                          </button>
                        </div>
                        <span className="text-sm font-serif text-gold" data-id="element-95">
                          {item.salePrice || item.price}
                        </span>
                      </div>
                    </div>
                  </div>)}
            </div>

            {cart.length > 0 && <div className="p-8 bg-gray-50 space-y-6" data-id="element-96">
                <div className="flex justify-between items-center text-lg" data-id="element-97">
                  <span className="font-serif" data-id="element-98">Subtotal</span>
                  <span className="font-bold text-gold" data-id="element-99">
                    ${subtotal.toFixed(2)}
                  </span>
                </div>
                <p className="text-[10px] text-gray-400 uppercase tracking-widest text-center" data-id="element-100">
                  Shipping and taxes calculated at checkout
                </p>
                <Link to="/checkout" onClick={() => toggleCart(false)} className="block w-full bg-black text-white py-5 text-xs uppercase tracking-[0.2em] font-bold hover:bg-gold transition-all duration-500 shadow-xl shadow-gold/10 text-center" data-id="element-101">
                  Proceed to Checkout
                </Link>
              </div>}
          </motion.div>
        </>}
    </AnimatePresence>;
}